import { Storage } from '@ionic/storage';
import { finalize } from 'rxjs/operators';
import { BasePage } from './../../base.page';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from 'src/app/services/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralService } from './../../../services/general.service';
import { WardrobeService } from './../../../services/wardrobe.service';
import { PaginatedResponse } from 'src/app/models/paginated-response.model';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import {
  ProductCategoryModel,
  ProductListingParamsModel,
  ProductModel,
} from './../../../models/wardrobe.model';
import { CategoryFilterModalComponent } from './../../../components/category-filter-modal/category-filter-modal.component';
import {
  IonInfiniteScroll,
  ActionSheetController,
  ModalController,
  LoadingController,
  Platform,
  ToastController,
} from '@ionic/angular';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

@Component({
  selector: 'shc-category-detail',
  templateUrl: './category-detail.page.html',
  styleUrls: ['./category-detail.page.scss'],
})
export class CategoryDetailPage extends BasePage implements OnInit {
  searchText: string;
  categoryId: number;
  isFiltered: boolean;
  filterSavedState: any;
  segmentCurrent: string;
  callInProgress: boolean;
  loadingMoreData = false;
  category: ProductCategoryModel;
  products: PaginatedResponse<ProductModel>;
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  params: ProductListingParamsModel = new ProductListingParamsModel();

  constructor(
    protected platform: Platform,
    protected userService: UserService,
    protected authService: AuthService,
    protected translate: TranslateService,
    private errorService: ErrorHandlerService,
    protected loadingCtrl: LoadingController,
    toastController: ToastController,
    private modalCtrl: ModalController,
    private wardrobeService: WardrobeService,
    private router: Router,
    private route: ActivatedRoute,
    private generalService: GeneralService,
    private actionSheetController: ActionSheetController,
    private localStorage: Storage,
  ) {
    super(
      platform,
      userService,
      authService,
      translate,
      loadingCtrl,
      toastController,
    );
  }

  ngOnInit() {
    console.log('cd');

    if (!this.segmentCurrent) {
      this.segmentCurrent = 'all';
    }
    this.categoryId = parseInt(this.route.snapshot.paramMap.get('id'), 10);
    this.getCategoryDetail();
    this.callInProgress = true;
    this.params = new ProductListingParamsModel();
    this.localStorage.get('category-filters').then((res) => {
      if (res) {
        this.filterSavedState = res;
        this.setFiltersParam(res);
      } else {
        this.setFiltersParam();
      }
    });
  }

  ionViewWillEnter() {}

  ionViewDidEnter() {}

  segmentChanged(ev: any): void {
    if (this.callInProgress) {
      return;
    }
    this.enableScrolll();
    this.params.page = 1;
    this.segmentCurrent = ev.target.value;
    this.setOrderBy(this.segmentCurrent);
    this.getCategoryProducts('');
  }

  setOrderBy(tab: string) {
    this.enableScrolll();
    if (tab === 'recent') {
      this.params.sort = 'created_at';
      this.params.direction = 'DESC';
    } else if (tab === 'popular') {
      this.params.sort = 'views';
      this.params.direction = 'DESC';
    } else {
      this.params.sort = null;
      this.params.direction = null;
    }
  }

  getCategoryDetail() {
    this.wardrobeService.categoryDetail(this.categoryId).subscribe(
      (res: ProductCategoryModel) => {
        this.category = res;
      },
      (error) => {
        this.errorService.handle(error);
      },
    );
  }

  getCategoryProducts(event) {
    // this.generalService.showLoader();
    // check if filters are applying or not
    this.params = this.clean(this.params);
    this.isFiltered = this.isFilterApplied(this.params, 'category');

    if (!this.loadingMoreData) {
      this.showLoader();
    }

    this.wardrobeService
      .productsList(this.params)
      .pipe(
        finalize(() => {
          if (!this.loadingMoreData) {
            this.hideLoader();
          } else {
            this.loadingMoreData = false;
          }
        }),
      )
      .subscribe(
        (res: PaginatedResponse<ProductModel>) => {
          this.callInProgress = false;
          if (this.products && this.products.meta) {
            if (this.params.page === 1) {
              this.products = res;
            } else {
              this.products.meta = res.meta;
              this.products.data = [...this.products.data, ...res.data];
            }
          } else {
            this.products = res;
          }
          if (event) {
            event.target.complete();
          }
          this.params.page++;
        },
        (error) => {
          this.callInProgress = false;
          this.errorService.handle(error);
        },
      );
  }

  async sortBy() {
    this.params.page = 1;
    this.enableScrolll();
    const actionSheet = await this.actionSheetController.create({
      mode: 'md',
      header: this.translate.instant(marker('SortBy.Title')),
      cssClass: 'CategoryDetails-action-sheet',
      buttons: [
        {
          text: this.translate.instant(marker('SortBy.NewlyListed')),
          handler: () => {
            this.params.sort = 'created_at';
            this.params.direction = 'DESC';
            this.getCategoryProducts('');
          },
        },
        {
          text: this.translate.instant(marker('SortBy.MostPopular')),
          handler: () => {
            this.params.sort = 'views';
            this.params.direction = 'DESC';
            this.getCategoryProducts('');
          },
        },
        // {
        //   text: this.translate.instant(marker('SortBy.LowestPrice')),
        //   handler: () => {
        //     this.params.sort = 'price';
        //     this.params.direction = 'ASC';
        //     this.getCategoryProducts('');
        //   },
        // },
        // {
        //   text: this.translate.instant(marker('SortBy.HighestPrice')),
        //   handler: () => {
        //     this.params.sort = 'price';
        //     this.params.direction = 'DESC';
        //     this.getCategoryProducts('');
        //   },
        // },
      ],
    });
    await actionSheet.present();
  }

  async openFilters() {
    const modal = await this.modalCtrl.create({
      component: CategoryFilterModalComponent,
      componentProps: {
        type: 'category',
        data: this.filterSavedState,
      },
      cssClass: 'product-filter',
      canDismiss: true,
      id: 'categoryFilters',
    });
    modal.onDidDismiss().then((data) => {
      if (data && data.data) {
        this.filterSavedState = data.data;
        this.setFiltersParam(data.data);
      }
      this.enableScrolll();
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  setFiltersParam(filters?: any) {
    this.params.page = 1;
    this.params.size_id = filters?.size?.id;
    this.params.type_id = filters?.type?.id;
    this.params.color_id = filters?.color?.id;
    this.params.brand_id = filters?.brand?.id;
    this.params.price_to = filters?.price?.upper;
    this.params.condition_id = filters?.condition;
    this.params.price_from = filters?.price?.lower;
    this.params.category_id = this.categoryId;
    this.params.latitude = filters?.latitude;
    this.params.longitude = filters?.longitude;
    this.params.location = filters?.location;
    this.setOrderBy(this.segmentCurrent);
    this.getCategoryProducts('');
  }

  loadData(event): void {
    if (this.products.meta.current_page < this.products.meta.last_page) {
      this.loadingMoreData = true;
      this.getCategoryProducts(event);
    } else {
      this.infiniteScroll.disabled = true;
    }
  }

  enableScrolll() {
    console.log('Called');
    if (this.infiniteScroll) {
      this.infiniteScroll.disabled = false;
    }
  }
}
